import { Feature } from 'ol';
import { Circle } from 'ol/geom';
import { toLonLat } from 'ol/proj';
import GeoJSON from 'ol/format/GeoJSON';
import { GeoJson } from '@ais-ui/api-spec/shapes';
import Geometry from 'ol/geom/Geometry';
import { getCircleTrueRadius } from './calculateCircleRadius';

const geometryToRawGeoJsonAndRadius = (
  geometry: Geometry,
  displayProjection: string,
  dataProjection: string
) => {
  if (geometry instanceof Circle) {
    const center = toLonLat(geometry.getCenter(), displayProjection);
    const geoJSON = {
      coordinates: center,
      type: 'Point',
    };
    const trueRadius = getCircleTrueRadius(
      geometry,
      displayProjection,
      dataProjection
    );
    const geoJsonRaw = JSON.stringify(geoJSON);
    return { geoJsonRaw, radius: trueRadius };
  } else {
    const geoJSON = new GeoJSON().writeGeometryObject(geometry, {
      dataProjection: dataProjection,
      featureProjection: displayProjection,
    });
    const radius = null;
    const geoJsonRaw = JSON.stringify(geoJSON);
    return { geoJsonRaw, radius };
  }
};

export const featureToShape = (
  feature: Feature | null,
  displayProjection: string,
  dataProjection: string
) => {
  const geometry = feature?.getGeometry();

  if (!geometry) {
    return;
  }

  const { geoJsonRaw, radius } = geometryToRawGeoJsonAndRadius(
    geometry,
    displayProjection,
    dataProjection
  );
  const geoJson: GeoJson = {
    type: 'Feature',
    geometry: JSON.parse(geoJsonRaw),
    properties: {
      name: 'Generated by MDM',
      description: '',
      parentId: '',
      acl: [],
    },
  };
  if (radius) {
    geoJson.properties.radius = radius;
  }

  return geoJson;
};
